import React, { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './src/styles.scss'
import { PrimeReactProvider } from 'primereact/api'
import { StoreProvider } from './src/app/store/store'
import { Graphql, client } from './src/app/graphql/graphql'
import { App } from './src/app/app'
import './src/styles.css'

const root = ReactDOM.createRoot(document.getElementById('app') as HTMLElement)

root.render(
  <StrictMode>
    <StoreProvider>
      <Graphql client={client}>
        <BrowserRouter basename="/support-admin">
          <PrimeReactProvider>
            <App />
          </PrimeReactProvider>
        </BrowserRouter>
      </Graphql>
    </StoreProvider>
  </StrictMode>
)
